import { commonConstants as cc } from 'srcReact/components'
import { groupConstants as gc } from 'srcReact/GroupPage'
import { groupService, feedService } from 'srcReact/services'
import { alertActions } from 'srcReact/Alert'

export const groupActions = {
  sendInvites,
  addComment,
  clearCommentState
}

function clearCommentState() {
  return { type: gc.CLEAR_COMMENT_STATE }
}

function sendInvites(group_id, usersId, message, callbackSuccess) {
  return (dispatch) => {
    dispatch(request({ group_id, usersId, message }))

    groupService.sendInvites(group_id, usersId, message).then(
      (response) => {
        dispatch(success(response))
        dispatch({ type: cc.POPIN_CLOSE })
        if (typeof callbackSuccess === 'function') {
          callbackSuccess()
        }
      },
      (error) => {
        dispatch(failure(error))
        dispatch(alertActions.error(error.message && error.message.toString()))
      }
    )
  }

  function request(response) {
    return { type: gc.SEND_INVITES_REQUEST, response }
  }
  function success(response) {
    return { type: gc.SEND_INVITES_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.SEND_INVITES_FAILURE, error }
  }
}

function addComment(group_id, comment, callback) {
  return (dispatch) => {
    dispatch(request({ group_id, comment }))
    feedService.getNewsFeed('group', group_id).then((responseFeed) => {
      if (responseFeed) {
        const newsFeedId = responseFeed && responseFeed.newsfeed && responseFeed.newsfeed.id
        feedService.postNewFeed(newsFeedId, comment).then(
          (response) => {
            dispatch(success(response))
            dispatch({ type: cc.POPIN_CLOSE })
            if (callback) {
              callback()
            }
          },
          (error) => {
            dispatch(failure(error))
          }
        )
      }
    })
  }

  function request(response) {
    return { type: gc.ADD_COMMENT_REQUEST, response }
  }
  function success(response) {
    return { type: gc.ADD_COMMENT_SUCCESS, response }
  }
  function failure(error) {
    return { type: gc.ADD_COMMENT_FAILURE, error }
  }
}
